<template>
  <div class="custom-page-box">
    <a-card title="安全设置" :bordered="false" :headStyle="{fontSize:'18px'}">
      <div class="item-box">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="账户密码">
            当前密码强度：<a>{{ passwordStrength ? passwordStrength : '弱' }}</a>
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onModifyPassword">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
      <div class="item-box">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="绑定手机号">
            已绑定手机：{{ getShowMobile(mobile) }}
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onModifyPhoneNumber">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
      <div class="item-box">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="登录手机号验证">
            未开启登录验证，手机号验证可有效保护账户安全
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onPhoneVerificationSettings">设置</a>
      </div>
      <a-divider type="horizontal"></a-divider>
      <div class="item-box">
        <detail-list :col="1" layout="vertical">
          <detail-list-item term="备用邮箱">
            已绑定邮箱：正在开发中
          </detail-list-item>
        </detail-list>
        <a class="right-button" @click="onModifyEmailAddress">修改</a>
      </div>
      <a-divider type="horizontal"></a-divider>
    </a-card>
    <a-modal
      title="修改密码"
      :width="500"
      v-model="visible"
      @ok="saveEvent"
      @cancel="visible=false"
      :destroyOnClose='false'
    >
      <a-form :form="form">
        <a-form-item>
          <a-input
            style="width: 100%"
            size="large"
            type="password"
            autocomplete="false"
            placeholder="旧密码"
            v-decorator="[
                'oldPassword',
                {rules: [{ required: true, message: '请输入旧密码' }], validateTrigger: 'blur'}
              ]"
          >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
        </a-form-item>
        <a-popover
          placement="rightTop"
          :trigger="['focus']"
          :getPopupContainer="(trigger) => trigger.parentElement"
          v-model="state.passwordLevelChecked">
          <template slot="content">
            <div :style="{ width: '240px' }">
              <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
              <a-progress :percent="state.percent" :showInfo="false" :strokeColor="passwordLevelColor "/>
              <div style="margin-top: 10px;">
                <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
              </div>
            </div>
          </template>
          <a-form-item>
            <a-input
              size="large"
              style="width: 100%"
              type="password"
              @click="handlePasswordInputClick"
              autocomplete="false"
              placeholder="新密码6 - 16位密码，区分大小写"
              v-decorator="['password', {rules: [{ required: true, message: '至少6位密码，区分大小写'}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"
            ></a-input>
          </a-form-item>
        </a-popover>
        <a-form-item>
          <a-input
            size="large"
            style="width: 100%"
            type="password"
            autocomplete="false"
            placeholder="确认密码"
            v-decorator="['password2', {rules: [{ required: true, message: '至少6位密码，区分大小写' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="修改绑定手机号"
      :width="800"
      v-model="bindVisible"
      @ok="saveEvent"
      @cancel="onBindCancel"
      :destroyOnClose='false'
    >
      <a-form :form="form">
        <a-form-item label="注册手机号码" v-bind="customFormItemLayout">
          <a-input
            :value="getShowMobile(mobile)"
            :disabled="true"
            placeholder="请输入手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="图形验证码" v-bind="customFormItemLayout">
          <a-input
            style="max-width: 400px"
            v-decorator="['verificationImg', {rules:[{required: true, message:'输入图形验证码'}]}]"
            placeholder="请输入">
          </a-input>
          <img :src="imageCodeUrl" alt="验证码" class="img-code" @click="restImageCodeUrl()">
        </a-form-item>
        <a-form-item label="短信验证码" v-bind="customFormItemLayout">
          <a-input
            v-decorator="['smsVerificationCode', {rules: [{ required: true, message:'请输入短信验证码'}], validateTrigger: 'change,blur'}]"
            placeholder="请输入短信验证码"
          ></a-input>
          <a v-if="second<=0" style="margin-left: 20px" @click="getSmsCode()">发送验证码</a>
          <a v-else style="margin-left: 20px">{{ second }}秒后重新发送</a>
        </a-form-item>
        <a-form-item label="新手机号" v-bind="customFormItemLayout">
          <a-input
            style="max-width: 400px"
            v-decorator="['newMobile', {rules: [{ required: true, validator: handlePhoneInput }], validateTrigger: 'blur'}]"
            placeholder="请输入新手机号"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import formMixin from '../../utils/mixins/formMixins'
import passwordMixins from '@/utils/mixins/passwordMixins'
import userHelper from '../../utils/helper/userHelper'
import countDownHelper from '../../utils/helper/countDownHelper'
import { mapActions } from 'vuex'

export default {
  name: 'SecuritySetting',
  mixins: [formMixin, passwordMixins],
  data() {
    return {
      customFormItemLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 19
        }
      },
      visible: false,
      bindVisible: false,
      newPassword: '',
      mobile: '',
      second: 0,
      imageCodeUrl: '',
      randomNum: '',
      passwordStrength: ''//密码强度
    }
  },
  mounted() {
    this.getRegisterMobile()
  },
  methods: {
    ...mapActions(['Logout']),
    getShowMobile(mobile) {
      if (mobile && mobile.length > 3) {
        return mobile.substr(0, 3) + '****' + mobile.substr(mobile.length - 4)
      }
      return mobile
    },
    onModifyPassword() {
      this.visible = true
      this.resetState()
      setTimeout(() => {
        this.resetForm()
      }, 1000)
    },
    onPhoneVerificationSettings() {
      this.$message.warn('该功能正在开发中')
    },
    onModifyPhoneNumber() {
      this.bindVisible = true
      this.restImageCodeUrl()
      setTimeout(() => {
        this.resetForm()
      }, 1000)

    },
    onModifyEmailAddress() {
      this.$message.warn('该功能正在开发中')
    },

    saveEvent() {
      this.validateFormParams()
        .then(values => {
          if (this.visible) {
            this.resetPasswordRequest(values)
          } else if (this.bindVisible) {
            this.bindPhoneRequest(values)
          }
        }).catch(reason => this.getLogUtils().errorWithTag('validateFormParams', reason))
    },
    resetPasswordRequest(values) {
      console.error('=resetPasswordRequest==', values)
      const params = {
        merchantMobile: this.mobile,
        passwordStrength: this.passwordLevelName,
        merchantNowPwd: userHelper.getPasswordEncrypt(values.oldPassword),
        merchantPwd: userHelper.getPasswordEncrypt(values.password)
      }
      this.getHttpServices().getUserService().post('merchant/v2/operate/resetPwdWithOutCaptcha', params)
        .then(res => {
          this.visible = false
          this.$message.success('密码修改成功,请重新登录')
          this.toReLogin()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    },
    getSmsCode() {
      const verificationImg = this.form.getFieldProps('verificationImg').props.value
      this.getLogUtils().logWithTag('verificationImg==', verificationImg)
      if (verificationImg && (typeof verificationImg === 'string' || typeof verificationImg === 'number')) {
        const params = {
          effect: 3,
          mobile: this.mobile,
          randomNum: this.randomNum,
          userType: 1,
          verificationImg: verificationImg
        }
        this.getHttpServices().getBaseService().post('sms/verification', params)
          .then(res => {
            this.$message.success('短信验证码已经发送')
            this.startTimer()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.success('请输入图形验证码')
      }

    },
    startTimer() {
      if (!this.timer) {
        this.timer = new countDownHelper(60000, 1000)
        this.timer.onCountDownListener = (timeInfo) => {
          this.second = timeInfo.second
        }
        this.timer.onFinishListener = () => {
          this.second = 0
          this.timer = undefined
        }
        this.timer.start()
      }
    },
    bindPhoneRequest(values) {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        merchantMobile: this.mobile,
        newMerchantMobile: values.newMobile,
        preventReSubmit: '',
        smsVerificationCode: values.smsVerificationCode
      }
      this.getHttpServices().getUserService().post('user/merchantInfo/mobileReplacement', params)
        .then(res => {
          this.onBindCancel()
          this.$message.success('手机号码修改成功,请重新登录')
          this.toReLogin()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toReLogin() {
      setTimeout(() => {
        this.Logout({}).then(() => {
          window.location.reload()
        }).catch(reason => console.error('Logout', reason))
      }, 500)
    },
    onBindCancel() {
      this.bindVisible = false
      if (this.timer) {
        this.timer.cancel()
        this.timer = undefined
      }
    },
    getRegisterMobile() {
      this.getHttpServices().getUserService().post('user/merchantInfo/getRegisterMobile')
        .then(detail => {
          this.mobile = detail.mobile
          this.passwordStrength = detail.passwordStrength
          this.getLogUtils().logWithTag('detail', detail)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }

  }

}
</script>
<style lang="less" scoped>
@import "../CustomPage";

.item-box {
  position: relative;
  height: 60px;
  width: 100%;
  line-height: 60px;

  .right-button {
    position: absolute;
    height: 60px;
    line-height: 60px;
    right: 0;
    top: 0;
  }

  .term {
    color: #444444;
    font-weight: bold;
  }
}

.img-code {
  margin-left: 20px;
  width: 130px;
  height: 40px;
}
</style>